import { Send } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { useMqtt } from '../../../context/MqttContext';

function MqttChatPage() {

    const [message,setMessage] = useState("");

    const {mqClient,publishMessage,newMessage} = useMqtt()

    const sendMessage = () =>{
        console.log("Sending this message", message);
        publishMessage(message)
    }

    useEffect(()=>{
        if(newMessage !== null){
            console.log(newMessage)
        }
    },[newMessage])

    return (
        <div className='container'>
            <div className='row mt-5'>
                
                <div className='offset-md-3 col-md-6'>
                    <div className='card'>
                        <div className='card-header'>Chat Test Page</div>
                        <div className='coard-body'>
                            
                        </div>
                        <div className='card-body'>
                            <div className='input-group mb-3'>
                                <input type="text" className='form-control'
                                    value={message}
                                    onChange={(e)=>setMessage(e.target.value)}
                                />
                                <button className='btn btn-outline-success' onClick={sendMessage} ><Send/></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MqttChatPage